<template>
  <div class="property_wrap formedit">
    <div class="pro_top">时间</div>
    <div class="pro_con">
      <el-form ref="form" :model="property" label-width="80px">
        <el-form-item label="提示语:">
          <el-input v-model="property.name" maxlength="6" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="property.checked">设为必填项</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
    };
  }
};
</script>


 